
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Redirect, useParams } from 'react-router';

import { useStore } from 'stores';
import * as paths from 'app-router/paths';
import Loading from 'components/Loading';
import { ErrorMessage } from 'components/Message';
import { LabeledIcon, ReloadIcon, TokensIcon } from 'components/Icon';
import { FormCard } from 'components/Card';

import { EditForm, UserInput } from './EditForm';

export const Page: React.FC = observer(() =>
{
  const [needToLoad, setNeedToLoad] = useState(true);
  const { requesterTokenToken } = useParams<{requesterTokenToken: string}>();
  const { uiStore, requesterTokenStore } = useStore();
  const [userInput, setUserInput] = useState<UserInput>({});

  const reloadDataHandler = async () => await requesterTokenStore.getByTokenAsync(requesterTokenToken);

  useEffect(() =>
  {
    if (!requesterTokenStore.requesterToken.data || requesterTokenStore.requesterToken.data.token !== requesterTokenToken)
    {
      requesterTokenStore.getByTokenAsync(requesterTokenToken);
    }
    setNeedToLoad(prev => false);
  }, [requesterTokenToken, requesterTokenStore, setNeedToLoad]);

  return (
    <article className="page audience requester-token-edit">
      <FormCard>
      {
        requesterTokenStore.requesterToken.isLoading || needToLoad
        ? <><h1>{uiStore.labels.common.loading}</h1><Loading /></>
        : requesterTokenStore.requesterToken.isError
          ? <>
              <h1>{uiStore.labels.common.anErrorOccured}</h1>
              <ErrorMessage>{requesterTokenStore.requesterToken.errorMessage} <button onClick={reloadDataHandler}><LabeledIcon label={uiStore.labels.common.tryAgain}><ReloadIcon/></LabeledIcon></button></ErrorMessage>
            </>
          : requesterTokenStore.requesterToken.data
            ? <>
                <h1><TokensIcon />{uiStore.labels.pages.audience.pages.requesterTokenEdit.title.apply({requesterToken: requesterTokenStore.requesterToken.data.token})}</h1>
                {requesterTokenStore.requesterToken.errorMessage ? <ErrorMessage>{requesterTokenStore.requesterToken.errorMessage}</ErrorMessage> : null}
                <EditForm userInput={userInput} saveUserInput={(input) => setUserInput(prev => input)} requesterToken={requesterTokenStore.requesterToken.data} />
              </>
            : <Redirect to={paths.buildNotFoundPath()} />
      }
      </FormCard>
    </article>
  );
});